export const createApi = ({baseUrl, onUnauthorized}) => {
    
    const request = async (endpoint, data = {}, options = {}) => {
        const isFormData = data instanceof FormData;

        const url = isFormData
        ? `${baseUrl}/api.php?endpoint=${encodeURIComponent(endpoint)}`
        : `${baseUrl}/api.php`

        const res = await fetch(url, {
            method: "POST",
            credentials: "include",
            headers: {
            ...(isFormData ? {} : { "Content-Type": "application/json" }),
            ...(options.headers || {}),
            },
            body: isFormData
            ? data
            : JSON.stringify({
                endpoint,
                data,
            }),
        });

        if(res.status === 401)
        {
            onUnauthorized?.();
            return null;
        }
        else if(res.status === 404)
        {
            
        }

        if(res.status === 204)
        {
            return null;
        }

        const rawText = await res.text();

        let body = rawText;

        try
        {
            body = JSON.parse(rawText);
        }
        catch
        {
            //console.log(rawText);
        }

        //console.log(body);

        if(!res.ok)
        {
            const error = new Error(
                body?.error || "HTTP_ERROR"
            );

            error.status = res.status;
            error.body = body;
            error.raw = rawText;

            throw error;
        }

        return body;
    }

    return {
        request,
        login: (data) => request("access/login", data),
        logout: () => request("access/logout"),
        me: () => request("access/me"),

        uploadImage: async (file, uploadUuid) => {
            const formData = new FormData()
            formData.append("file", file)
            formData.append("uploadUuid", uploadUuid)

            const response = await request("image/upload", formData)

            return response;
        }
    };
}